import { IApplicationState } from '../../types/redux';

export const selectOfferById = (state: IApplicationState, id: number) => {
  return state.listingOffers.offers.find(of => of.id === id || of.cianId === id);
};
